import { css, styled } from '../../hooks/theme';
import { getCssFont } from '../../styles';
import { Tokens } from '../../types';
import { JustifyContent } from './Radio.types';

interface LabelProps {
  checked?: boolean;
  disabled?: boolean;
  bordered?: boolean;
  side?: 'right' | 'left';
  hasContent?: boolean;
  width?: string;
  justifyContent: JustifyContent;
}

const getHoverStyle = props => css`
  &:hover {
    ${!props.disabled &&
    props.bordered &&
    css`
      border: 1px solid ${props.theme.colors.neutral.grey[100]};
    `}
  }
`;
export const Label = styled.label<LabelProps>`
  --radio-primary-color: ${props => props.theme.colors.brand.primary[100]};
  --radio-disabled-color: ${props => props.theme.colors.neutral.grey[40]};
  ${getCssFont(Tokens.eixods.font.desktop.paragraph.p2.regular)}
  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}
  display: flex;
  align-items: center;
  justify-content: ${props => props.justifyContent};

  gap: 0.5rem;
  color: ${props => props.theme.colors.neutral.grey[100]};
  background: ${props => props.theme.colors.neutral.grey[0]};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  ${props =>
    props.bordered &&
    css`
      padding: 12px 16px;
      border: 1px solid var(--radio-disabled-color);
      border-radius: 4px;
      ${getHoverStyle(props)}
    `};
  ${props =>
    props.checked &&
    props.bordered &&
    css`
      border: 1px solid var(--radio-primary-color);
      }
    `}
  ${props =>
    props.disabled &&
    css`
      color: var(--radio-disabled-color);
    `};

  ${props => getHoverStyle(props)}

  @media screen and (max-width: ${Tokens.breakpoints.mobile}px) {
    flex-wrap: wrap;
  }

  input[type='radio'] {
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    margin: 0;

    font: inherit;
    color: currentColor;
    width: 1.5rem;
    min-width: 1.5rem;
    height: 1.5rem;
    border: 1px solid var(--radio-disabled-color);
    border-radius: 50%;
    transform: translateY(-0.075em);

    display: grid;
    place-content: center;

    ${props =>
      props.side === 'left' &&
      css`
        order: 2;
      `}
  }
  input[type='radio']::before {
    content: '';
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em
      ${props =>
        props.disabled ? css`var(--radio-disabled-color)` : css`var(--radio-primary-color)`};
    /* Windows High Contrast Mode */
    /* background-color: CanvasText; */
  }
  input[type='radio']:checked::before {
    transform: scale(1);
  }
  input[type='radio']:checked {
    border-color: var(--radio-primary-color);
  }
  input[type='radio']:disabled {
    border-color: var(--radio-disabled-color);
  }

  /* &:focus-within {
    color: var(--primary-color);
  } */

  /* input[type='radio']:focus {
      outline: max(2px, 0.15em) solid currentColor;
      outline-offset: max(2px, 0.15em);
    } */
  &:has(> input[type='radio']:checked) {
    ${props =>
      props.bordered &&
      css`
        border: 1px solid var(--radio-primary-color);
        ${getHoverStyle(props)}
      `}
  }
  &:has(> input[type='radio']:disabled) {
    ${props =>
      props.bordered &&
      css`
        border: 1px solid var(--radio-disabled-color);
      `}
  }
`;
Label.defaultProps = {
  theme: Tokens.eixods,
};
export const LabelContainer = styled.div``;
interface ContentTextProps {
  disabled?: boolean;
}
export const ContentText = styled.div<ContentTextProps>`
  ${getCssFont(Tokens.eixods.font.desktop.paragraph.p3.regular)};
  color: ${props =>
    props.disabled ? css`var(--radio-disabled-color)` : props.theme.colors.neutral.grey[70]};
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;

  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;
ContentText.defaultProps = {
  theme: Tokens.eixods,
};
